<div class="modal-header">
    <h3>{{modalData.modalTitle}}</h3>
</div>
<div class="modal-body">
    <div [innerHtml]="modalData.modalMessage"></div>
</div>
<div class="modal-footer">
    <button *ngIf="modalData.modalAction != null" type="button" id="{{modalData.actionID}}" class="btn" [ngClass]="{'btn-danger': (modalData.warningLevel == null || modalData.warningLevel == 'danger'), 'btn-primary': modalData.warningLevel == 'primary', 'btn-success': modalData.warningLevel == 'success'}"
            (click)="actionClicked()">
        {{modalData.modalAction}}
    </button>
    <button type="button" class="btn btn-outline-dark"
            (click)="cancelClicked()">
        {{closeButtonText}}
    </button>
</div>
